import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import EmptyState from 'Components/EmptyState/EmptyState';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { getCaseHistoryData } from './configStructure'
import moment from 'moment';
import './CaseEventsLog.scss'
const caseHistoryData = getCaseHistoryData();


const CaseEventsLog = (props) => {
    return <div className="case-events-log" >
        {
          props.historyDataErr && !props.historyDataLoading && (
            <EmptyState
                translations={{ emptyStateHeading: 'Case Audit log not available.', emptyStateDescription: '' }}
            />
          )
        }
        {props.historyDataLoading && <div className="ball-sync-loader loader" style={{ height: 300, backgroundColor: 'white' }}><BVLoader20 /></div>}
        {!props.historyDataErr && props.historyData && props.historyData.length > 0 && <table cellPadding="8%" >
            <thead>
                <tr className="case-events-log-header" >
                    {
                        caseHistoryData.dataColumns?.map((column, index) => {
                            return <th key={`header-${index}`} style={{ "width": `${column.width}` }}>{column.name}</th>
                        })
                    }
                </tr>
            </thead>
            <tbody>
                {
                    props.historyData.map((values, index) => {
                        return (
                            <tr key={index} className="case-events-log-content" >
                                {
                                    caseHistoryData.dataColumns?.map((column, rowIndex) => {
                                        let value;
                                        switch (column.displayType) {
                                            case "DATE":
                                                value = format(values[column.columnKey], `${props.dateFormat} ${props.timeFormat}`)
                                                break;
                                            case "STRING":
                                                value = values[column.columnKey];
                                                break;
                                            default:
                                                value = values[column.columnKey];
                                                break;
                                        }
                                        return <td key={`${index}-${rowIndex}`} style={{ width: `${column.width}`, wordBreak: "break-word" }}>{value}</td>
                                    })
                                }

                            </tr>
                        );
                    })
                }
            </tbody>
        </table> 
        }</div>

}

CaseEventsLog.propTypes = {
    historyData: PropTypes.array,
};

CaseEventsLog.defaultProps = {
    historyData: [],
};

export default (CaseEventsLog);